module.exports = __webpack_public_path__ + "img/logo-veracruz.ef9fd377.png";